export default {
  title: 'Ship Data Management',

  // Search filter area
  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Ship name, IMO number, call sign',
    shipType: 'Ship Type',
    shipTypePlaceholder: 'Select ship type',
    country: 'Country',
    countryPlaceholder: 'Select country',
    status: 'Status',
    statusPlaceholder: 'Select status',
    allStatus: 'All Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  // Action buttons
  actions: {
    addShip: 'Add Ship',
    selectFromLibrary: 'Add Ship',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    edit: 'Edit',
    enable: 'Enable',
    disable: 'Disable',
    recordsCount: 'Total {count} records'
  },

  // Table columns
  table: {
    shipName: 'Ship Name',
    imoNumber: 'IMO Number',
    shipType: 'Ship Type',
    flag: 'Flag',
    callSign: 'Call Sign',
    capacity: 'DWT',
    builtYear: 'Built Year',
    owner: 'Owner',
    status: 'Status',
    operation: 'Operation'
  },

  // Form
  form: {
    addTitle: 'Add Ship',
    editTitle: 'Edit Ship',
    shipName: 'Ship Name',
    shipNamePlaceholder: 'Please enter ship name',
    imoNumber: 'IMO Number',
    imoNumberPlaceholder: 'Please enter IMO number',
    imoNumberHint: 'Must be 7 digits',
    shipType: 'Ship Type',
    shipTypePlaceholder: 'Select ship type',
    flag: 'Flag',
    flagPlaceholder: 'Please select flag',
    callSign: 'Call Sign',
    callSignPlaceholder: 'Please enter call sign',
    capacity: 'DWT',
    capacityPlaceholder: 'Please enter DWT',
    builtYear: 'Built Year',
    builtYearPlaceholder: 'Please enter built year',
    owner: 'Owner',
    ownerPlaceholder: 'Please enter owner',
    status: 'Status',
    statusPlaceholder: 'Select status'
  },

  // Ship types
  shipTypes: {
    container: 'Container Ship',
    bulk: 'Bulk Carrier',
    tanker: 'Tanker',
    general: 'General Cargo',
    roro: 'RoRo Ship',
    other: 'Other'
  },

  // Selection modal
  modal: {
    title: 'Select Ship',
    confirmText: 'Confirm Add ({count})',
    selected: 'Selected {count} ships, {total} available'
  },

  // Confirmation dialogs
  confirm: {
    enableItem: 'Are you sure to enable this ship?',
    disableItem: 'Are you sure to disable this ship?',
    batchEnable: 'Are you sure to enable the selected {count} ships?',
    batchDisable: 'Are you sure to disable the selected {count} ships?'
  },

  // Form validation
  validation: {
    shipNameRequired: 'Please enter ship name',
    shipNameMinLength: 'Ship name must be at least 2 characters',
    shipNameMaxLength: 'Ship name cannot exceed 100 characters',
    imoNumberRequired: 'Please enter IMO number (must be 7 digits)',
    imoNumberFormat: 'IMO number must be 7 digits',
    shipTypeRequired: 'Please select ship type',
    capacityRequired: 'Please enter DWT',
    builtYearRequired: 'Please enter built year',
    callSignRequired: 'Please enter call sign',
    callSignMinLength: 'Call sign must be at least 3 characters',
    callSignMaxLength: 'Call sign cannot exceed 10 characters',
    callSignFormat: 'Call sign can only contain letters and numbers',
    flagRequired: 'Please select flag',
    selectItems: 'Please select ships to associate',
    checkRequired: 'Please fill in all required fields'
  },

  // Message prompts
  messages: {
    selectToEnable: 'Please select ships to enable',
    selectToDisable: 'Please select ships to disable',
    selectToAssociate: 'Please select ships to associate',
    loadError: 'Failed to load ship data, please try again later',
    apiNotFound: 'Ship data API not found, please contact administrator',
    serverError: 'Internal server error, please try again later',
    platformLoadError: 'Failed to load platform ship data, please try again later',
    saveSuccess: 'Ship saved successfully',
    saveError: 'Failed to save, please try again later',
    updateSuccess: 'Ship updated successfully',
    updateError: 'Failed to update, please try again later',
    checkRequired: 'Please fill in all required fields',
    associateSuccess: 'Successfully associated {count} ships',
    associateError: 'Failed to associate, please try again later',
    statusToggleSuccess: 'Ship has been {status}',
    statusToggleError: 'Failed to toggle status, please try again later',
    batchEnableSuccess: 'Enabled {count} ships',
    batchEnableError: 'Failed to batch enable, please try again later',
    batchDisableSuccess: 'Disabled {count} ships',
    batchDisableError: 'Failed to batch disable, please try again later'
  },

  // Status text
  statusText: {
    enabled: 'enabled',
    disabled: 'disabled'
  },

  // Country options
  countries: {
    CHN: 'China',
    PAN: 'Panama',
    LBR: 'Liberia',
    SGP: 'Singapore',
    MHL: 'Marshall Islands',
    HKG: 'Hong Kong',
    MLT: 'Malta',
    CYP: 'Cyprus',
    BHS: 'Bahamas'
  }
}
